import styled from "styled-components";
import { Text } from "../../../config/Constants";
import Table from "../../DataTable";
import { getFormattedDate } from "../../getFormattedDate";
import ListWithPagination from "../../ListsWithPagination";
import { useNavigate } from "react-router-dom";
import { titleCase } from "../../../helper";

interface Props {
  data: {
    id: string;
    name: string;
    phone: string;
    createdAt: string;
    visitDate: string;
    visiTime: string;
    vesselLoa: string;
    package: string;
    additionalService: boolean;
  }[];
  isTableDataLoading: boolean;
}

const YachtClubRegistrationTable = ({ data, isTableDataLoading }: Props) => {
  const navigate = useNavigate();
  const getLinkText = (linkText: string, id: string) => (
    <StyledLinkText
      onClick={() => {
        navigate(`/admin/view-details/${id}`);
      }}
    >
      {linkText}
    </StyledLinkText>
  );

  const columns = [
    {
      path: "name",
      label: "Name",
      content: (data: { name: string }) => <div>{titleCase(data.name)}</div>,
    },
    {
      path: "phone",
      label: "Contact",
    },
    {
      path: "createdAt",
      label: "Created on",
      content: (data: any) => (
        <DateAndTimeWrapper>
          <div>{getFormattedDate(data.createdAt, "YYYY-MM-DD")}</div>
          <div>{getFormattedDate(data.createdAt, "HH:mm")}</div>
        </DateAndTimeWrapper>
      ),
    },
    {
      label: "Visit Date & Time",
      content: (data: { visitDate: string; visiTime: string }) => (
        <DateAndTimeWrapper>
          <div>{data.visitDate}</div>
          <div>{data.visiTime}</div>
        </DateAndTimeWrapper>
      ),
    },
    {
      path: "vesselLoa",
      label: "LOA(m)",
    },
    {
      path: "package",
      label: "Package",
      content: (data: { package: string }) => (
        <div>
          {data.package === "dropOrPickUp"
            ? "DropOff/PickUp"
            : titleCase(data.package)}
        </div>
      ),
    },
    {
      path: "additionalService",
      label: "Additional Services",
      content: (data: { additionalService: boolean }) => (
        <div>{data.additionalService === true ? "Yes" : "No"}</div>
      ),
    },
    {
      path: "registrationDetail",
      label: "Registration Detail",
      content: (data: { id: string }) => getLinkText("View Detail", data.id),
    },
  ];

  return (
    <>
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={Text.yachtClubRegistrationDetailsHeader}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledLinkText = styled.button`
  background: transparent;
  border: none;
  color: #2ca5ff;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Poppins-Medium";
  font-weight: 500;
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const DateAndTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default YachtClubRegistrationTable;
